import {BaseDTO} from '../../common/models/BaseDTO';

export class IssueTicketAttachmentsDTO extends BaseDTO {
  issueTicketAttachmentsId: bigint;
  fileId: bigint;
}
